const T = (c, t, f, s) => !!(c === t || c === `${t}.${f}` || s != null && s.find((o) => c === `${t}.${o}`)), $ = (c, t) => {
  const f = c.carticles.map(({ id: r }) => r), s = [...c.tattrs], o = [...c.tables];
  return t != null && t.length && c.carticles.forEach(({ variants: r }) => {
    r.forEach(({ id: l, childs: b }) => {
      if (!t.includes(l))
        return;
      const i = $(b, t);
      f.push(...i.carticles), s.push(...i.tattrs), o.push(...i.tables);
    });
  }), {
    carticles: f,
    tattrs: s,
    tables: o
  };
}, F = (c, t) => {
  const f = [], s = [], o = [], r = [], l = [], b = [], i = [], m = [], w = [];
  return c == null || c.forEach(({ carticles: a }) => {
    a.forEach(({ id: S, variants: g, parents: u }) => {
      g.forEach(({ id: n, tattrs: h, tables: p }) => {
        r.push(...h), t != null && t.includes(n) && l.push(...h), b.push(...p), t != null && t.includes(n) && i.push(...p);
      }), u != null && u.length && (m.push(S), u.forEach((n) => {
        t != null && t.includes(n) && w.push(S);
      }));
    });
  }), c.forEach((a) => {
    const S = a.carticles.filter(({ id: n, countBody: h, countVariative: p }) => (
      // если вариации нет в вариациях или вариация в выбранной вариации
      !m.includes(n) || w.includes(n) || h && p && h > p
    )).map(({ id: n }) => n);
    f.push(...S);
    const g = a.tattrFolders.flatMap((n) => n.tattrs.filter(({ id: h, countBody: p, countVariative: _ }) => h ? !r.length || !r.find((E) => T(E, h, a.id, a.sidesIds)) || l.find((E) => T(E, h, a.id, a.sidesIds)) || p && _ && p > _ : !1).map(({ id: h }) => `${h}.${a.id}`));
    s.push(...g);
    const u = a.tables.filter(({ id: n }) => (
      // если таблицы нет в вариациях или таблица в выбранной вариации
      !b.includes(n) || i.includes(n)
    )).map(({ id: n }) => n);
    o.push(...u);
  }), {
    carticles: f,
    tattrs: s,
    tables: o
  };
}, C = (c, t, f) => {
  const s = [], o = [], r = [];
  if (t) {
    const l = $(t, f);
    s.push(...l.carticles), o.push(...l.tattrs), r.push(...l.tables);
  } else {
    const l = F(c, f);
    s.push(...l.carticles), o.push(...l.tattrs), r.push(...l.tables);
  }
  return {
    carticles: [...new Set(s)],
    tattrs: [...new Set(o)],
    tables: [...new Set(r)]
  };
}, I = (c, t, f) => {
  if (!!!(c != null && c.find(({ carticles: r }) => !!(r != null && r.length))))
    return c;
  const o = C(c, t, f);
  return c.map(({ id: r, sidesIds: l, tattrFolders: b, tables: i, carticles: m, ...w }) => {
    const a = m.filter(({ id: u }) => o.carticles.includes(u)), S = b.map((u) => ({
      ...u,
      tattrs: u.tattrs.filter(({ id: n }) => n && o.tattrs.find((h) => T(h, n, r, l)))
    })), g = i.filter(({ id: u }) => o.tables.includes(u));
    return {
      id: r,
      tattrFolders: S,
      tables: g,
      carticles: a,
      ...w
    };
  });
};
export {
  I as default,
  C as getSidesIdsToShow
};
